import { Injectable } from '@angular/core';
import { BackendService } from '@toro/common/shared/services/new-http/backend.service';
import { Observable } from 'rxjs';


export enum CheckoutNotifierProductType {
    BOLSA = 'Bolsa',
}
export enum CheckoutNotifierActionType {
    OrderSuccess = 'ORDEM ENVIADA',
    OrderRejected = 'ORDEM REJEITADA',
    Visualization = 'VISUALIZACAO',
    BuyAttempt = 'TENTATIVA DE COMPRA',
}

export class CheckoutNotifierIitem {
    constructor(
        public name: string,
        public id: number,
    ) { }
}

export class CheckoutNotifierPayload {
    constructor(
        public cblc: string | number,
        public dateOperation: number,
        public productType: CheckoutNotifierProductType,
        public userActionType: CheckoutNotifierActionType,
        public items: CheckoutNotifierIitem[],
        public message?: string,
    ) { }
}

@Injectable({ providedIn: 'root' })
export class CheckoutNotifierService extends BackendService {

    private checkoutNotifierUrl = 'checkout-notifier/v1/send-to-topic';

    /**
     * Function that sends a checkout intention to checkout notifier endpoint
     * @param payload checkout action
     */
    public sendCheckoutNotifierIntention(payload: CheckoutNotifierPayload) {

        try {
            return this.toroCrmAws.post(this.checkoutNotifierUrl, payload);
        } catch (_) {
            return Observable.of(false)
        }
    }
}
